import React from "react";
import TranscriptLine from "./TranscriptLine";

const STAR_COLOR = "#f4c542";

const formatDate = (isoDate) => {
  const d = new Date(isoDate);
  return `${d.toLocaleDateString(undefined, { month: 'long', day: 'numeric', year: 'numeric' })} – ${d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
};

const RecordingExpandedCard = ({
  rec,
  labelUpdateKey,
  transcriptToggles,
  setTranscriptToggles,
  audioUrl,
  updateSpeakerLabel,
  handleDeleteRecording
}) => {
  const segments = [...rec.text.matchAll(/(SPEAKER_\d{2}) \[(\d+\.\d+)-(\d+\.\d+)\]:\s*(.*?)(?=SPEAKER_\d{2}|\s*$)/gs)];
  const showAll = transcriptToggles[rec.id];

  return (
    <tr className="expanded-row" key={`expanded-${rec.id}-${labelUpdateKey}`}>
      <td colSpan="4">
        <div className="recording-card">
          <div className="recording-meta">
            {formatDate(rec.created_at)}
            {rec.is_starred && (
              <span style={{ color: STAR_COLOR, marginLeft: 12, fontWeight: 600 }}>
                <span role="img" aria-label="Starred">★</span> Starred for manager review
              </span>
            )}
          </div>
          <div className="transcript">
            {(showAll ? segments : segments.slice(0, 3)).map((match, index) => (
              <TranscriptLine
                key={index}
                match={match}
                rec={rec}
                updateSpeakerLabel={updateSpeakerLabel}
              />
            ))}
            {segments.length > 3 && (
              <button className="show-more-button" onClick={() =>
                setTranscriptToggles(prev => ({ ...prev, [rec.id]: !prev[rec.id] }))
              }>
                {showAll ? "Show Less" : "Show More"}
              </button>
            )}
          </div>
          <div className="expanded-controls">
            <div className="audio-wrapper">
              <audio
                id={`audio-${rec.id}`}
                controls
                src={audioUrl || ""}
              />
            </div>
            <button
              className="delete-button full-width"
              onClick={() => handleDeleteRecording(rec.recording_id)}
            >
              Delete Recording
            </button>
          </div>
        </div>
      </td>
    </tr>
  );
};

export default RecordingExpandedCard;
